const STEPS = {
  SCHEDULE: 'schedule',
}

const DATE_SEQUENCE_STATUS = {
  ACTIVE: 'ACTIVE',
  ENDED: 'ENDED',
  PAUSED: 'PAUSED',
}

export { DATE_SEQUENCE_STATUS, STEPS }
